/**
 * A ZTA user account's status, as a vocabulary word for OutcomeBadge (cascade plan 5.2).
 *
 * The shared vocabulary (lib/tone.ts, d2d-XDR's) reads "active" as a newly opened
 * item. An active ACCOUNT is healthy and in use, so it is passed as "online"
 * (resolved); a suspended one as "disabled" (closed). Anything else passes through.
 */
export function userStatusValue(status: string | null | undefined): string | null | undefined {
  if (status === 'active') return 'online';
  if (status === 'suspended') return 'disabled';
  return status;
}
